export default __webpack_public_path__ + "static/media/doller-icon-white.2ad04532.svg";